module.exports = __webpack_public_path__ + "static/media/036.19cc8e06.jpg";